import { render } from "./OptionInstallType.vue?vue&type=template&id=631058d6&scoped=true"
import script from "./OptionInstallType.vue?vue&type=script&lang=js"
export * from "./OptionInstallType.vue?vue&type=script&lang=js"

import "./OptionInstallType.vue?vue&type=style&index=0&id=631058d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631058d6"]])

export default __exports__